import {useDispatch, useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import OverwolfGoVipAccountLevel from "@/pages/overwolf/components/OverwolfGoVipAccountLevel";
import OverwolfGoVipRewards from "@/pages/overwolf/components/OverwolfGoVipRewards";
import FrameButton from "@/components/buttons/FrameButton";
import {useEffect, useState} from "react";
import MagicLoginModal from "@/components/modals/MagicLoginModal";
import {toggleSidebar} from "@/redux/meta/metaActions";
import OverwolfIndustryPassPromoBanner from "@/pages/overwolf/components/OverwolfIndustryPassPromoBanner";
import useGetOverwolfArt, {OverwolfArtType} from "@/hooks/useGetOverwolfArt";
import OverwolfGameLogo from "./components/OverwolfGameLogo";
import {ThemePreference} from "@/types/Theme";
import useThemePreference from "@/hooks/useThemePreference";
import {store} from "@/redux";
import OverwolfDiscordBanner from "@/pages/overwolf/components/OverwolfDiscordBanner";
import OWAnnouncementModal from "@/components/devourPlay/OWAnnouncementModal";
import { OverwolfGoVipSummary } from "./components/OverwolfGoVipSummary";
import classNames from "classnames";
import useWindowSize from "@/hooks/useWindowSize";

const DEVOUR_CDN = import.meta.env.VITE_CDN_URL;

export default function OverwolfGoVip() {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const { getOverwolfArt} = useGetOverwolfArt(OverwolfArtType.bannerImage);
    const dispatch = useDispatch();
    const {setTheme} = useThemePreference();
    const windowSize = useWindowSize()[0];
    const isInGameView = windowSize < 400;
    const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(true); // TODO: Set this if you want to show feature announcement modal

    // Close the sidebar menu if open
    useEffect(() => {
        dispatch(toggleSidebar(false));
        const originalTheme = store.getState().metaStore.themePreference;
        setTheme(ThemePreference.DARK);
        return () => {
            if (originalTheme) {
                setTheme(originalTheme);
            }
        };
    }, []);

    return (
        <>
            <OWAnnouncementModal
                isOpen={isAnnouncementModalOpen}
                onClose={() => setIsAnnouncementModalOpen(false)}
                version={"3.0.0"}
                title={`Check 'Discover' Page${isInGameView ? "\n" : " "}to Learn More 🚀`}
                link={"/overwolf-discover"}
                description={"Hey fam, thanks for rolling with us 💜 Check out our new 'Discover' tab — it’s packed with guides and tips to help you crush it on DevourPlay. Dive in and explore all the epic ways to earn XP, level up and unlock rewards! 😎⚡"}
                video={`${DEVOUR_CDN}/videos/OW-Discover-Announcement-${isInGameView ? "SM" : "LG"}.mp4`}
                size={isInGameView ? "xs1" : "xs2"}
            />

            <div
                className="overwolf-govip"
                style={{
                    backgroundImage: `url(${getOverwolfArt})`,
                }}
            >
                <MagicLoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)}/>

                <div className="overwolf-govip_content">
                    <div className="overwolf-govip_header">
                        <OverwolfGameLogo/>
                        <h1>PLAY TO EARN</h1>
                    </div>
                    <div className={classNames({
                        "overwolf-govip_content_summary": !!fullToken,
                    })}>
                        <OverwolfGoVipAccountLevel/>
                        { fullToken && <OverwolfGoVipSummary/>}
                    </div>

                    <OverwolfIndustryPassPromoBanner/>

                    <OverwolfGoVipRewards/>
                </div>

                {!fullToken && <FrameButton
                    size="large"
                    className="overwolf-govip_login-btn overwolf-govip_button_purple-blue-gradient-shadow"
                    onClick={() => setIsLoginModalOpen(true)}
                >
                    Login or Sign up
                </FrameButton>
                }
            </div>
            {fullToken && <OverwolfDiscordBanner />}
        </>

    );
}
